class ProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    const root = this.querySelector('template.root').content.cloneNode(true);
    this.shadowRoot.appendChild(root);
    this.querySelector('template.root').remove();

    this.splide = null;
  }

  connectedCallback() {
    const { intent } = this.dataset;
    if (intent === 'related' || intent === 'complementary') {
      this.fetchProducts();
    } else {
      // For collection and product-list modes, just initialize the carousel
      this.initSplide();
    }
  }

  async fetchProducts() {
    const { baseUrl, sectionId, productId, limit, intent } = this.dataset;
    const url = `${baseUrl}?product_id=${productId}&limit=${limit}&section_id=${sectionId}&intent=${intent}`;
    const response = await fetch(url);
    const data = await response.text();
    // console.log(data);


    const parser = new DOMParser();
    const doc = parser.parseFromString(data, 'text/html');
    const clone = doc.querySelector('layout-component template.root').content.querySelector('product-carousel template.root').content.querySelector('.splide__list').cloneNode(true);
    const content = this.shadowRoot.querySelector('.splide__list');
    content.innerHTML = clone.innerHTML;
    
    // Initialize Splide after content is loaded
    this.initSplide();
  }
  
  initSplide() {
    const sliderElement = this.shadowRoot.querySelector('.splide');

    if (!sliderElement) {
      console.warn('splide element not found');
      return;
    };

    this.splide = new Splide(sliderElement, {
    });

    this.splide.on('overflow', (isOverflow) => {
      this.splide.options = {
        arrows: isOverflow && this.splide.options.arrows,
      }
    });
    
    // Add resize handler to ensure proper width is maintained
    window.addEventListener('resize', () => {
      if (this.splide) {
        this.splide.refresh();
      }
    });

    this.splide.mount();
  }
}

customElements.define('product-carousel', ProductCarousel);